export default __webpack_public_path__ + "static/media/crwn-small.e173121c.png";